module.exports = __webpack_public_path__ + "img/coconut-cocktail.e4a0feba.png";